export function scale2Zoom(scale) {
  if (scale <= 10) return 19
  else if (scale <= 25) return 18
  else if (scale <= 50) return 17
  else if (scale <= 100) return 16
  else if (scale <= 200) return 15
  else if (scale <= 500) return 14
  else if (scale <= 1000) return 13
  else if (scale <= 2000) return 12
  else if (scale <= 5000) return 11
  else if (scale <= 10000) return 10
  else if (scale <= 20000) return 9
  else if (scale <= 30000) return 8
  else if (scale <= 50000) return 7
  else if (scale <= 100000) return 6
  else if (scale <= 200000) return 5
  else if (scale <= 500000) return 4
  else if (scale <= 1000000) return 3
  else if (scale > 1000000) return 2
  return 20
}

export function zoom2Scale(zoom) {
  if (zoom == 19) return 10
  else if (zoom == 18) return 25
  else if (zoom == 17) return 50
  else if (zoom == 16) return 100
  else if (zoom == 15) return 200
  else if (zoom == 14) return 500
  else if (zoom == 13) return 1000
  else if (zoom == 12) return 2000
  else if (zoom == 11) return 5000
  else if (zoom == 10) return 10000
  else if (zoom == 9) return 20000
  else if (zoom == 8) return 30000
  else if (zoom == 7) return 50000
  else if (zoom == 6) return 100000
  else if (zoom == 5) return 200000
  else if (zoom == 4) return 500000
  else if (zoom == 3) return 1000000
  else if (zoom == 2) return 1000000
  return 1000000
}